import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type AddPackageDTO = {
    name:string;
    description:string;
    img_url:string;
    actualPrice_egp:string;
    actualPrice_usd:string;
};

type PackageResponse  = AddPackageDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const AddNewPackage = (data: AddPackageDTO): Promise<PackageResponse> => {
    return axios.post("/package/create", data)
        .then(response => response.data as PackageResponse);
};